import { base44 } from '@/api/base44Client';

export const OFFICIAL_TEAM_MEMBERS = [
  { name: 'Muhammad Fadli', role: 'Developer Web', dept: 'Developer' },
  { name: 'Umar Syarif', role: 'Direktur Utama', dept: 'Owner / Direksi' },
  { name: 'Anissa Nurul Fadilah', role: 'Finance', dept: 'Office' },
  { name: 'Ahmad Rifai', role: 'Purchasing', dept: 'Office' },
  { name: 'Adnan Hasan', role: 'Marketing', dept: 'Office' },
  { name: 'Ahmad', role: 'Marketing', dept: 'Office' },
  { name: 'Yositasari', role: 'Apoteker Penanggung Jawab', dept: 'Apoteker' },
  { name: 'Mohamad Irpan', role: 'Kepala Produksi Primer', dept: 'Produksi' },
  { name: 'Agus Setiawan', role: 'Staff Pengemasan Sekunder', dept: 'Produksi' }
];

export const PORTAL_STRUCTURE = [
  {
    id: 'finance',
    name: 'Finance & Kas',
    color: 'bg-emerald-600 text-white',
    badgeColor: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    pages: [
      { id: 'all', name: 'Semua Halaman Finance' },
      { id: 'dashboard_finance', name: 'Dashboard Finance', route: '/office/finance' },
      { id: 'rekening_kas', name: 'Rekening & Mutasi', route: '/office/finance/accounts' },
      { id: 'calculator', name: 'Pembuatan Invoice & SPH', route: '/office/finance/calculator' },
      { id: 'sph_list', name: 'Daftar SPH', route: '/office/finance/sph-list' },
      { id: 'invoice_po', name: 'Invoice & PO', route: '/office/finance/invoices' },
      { id: 'custom_invoices', name: 'Invoice Custom & Sample', route: '/office/finance/custom-invoices' },
      { id: 'payables', name: 'Hutang Perusahaan', route: '/office/finance/payables' },
      { id: 'receivables', name: 'Piutang Klien', route: '/office/finance/receivables' },
      { id: 'purchasing_requests', name: 'Pengajuan Pembelian', route: '/office/finance/purchasing-requests' },
      { id: 'production_costs', name: 'Biaya Produksi', route: '/office/finance/production-costs' },
      { id: 'operasional', name: 'Biaya Operasional', route: '/office/finance/operational' },
      { id: 'payroll', name: 'Gaji & Karyawan', route: '/office/finance/payroll' },
      { id: 'laporan', name: 'Rekap Laporan Biaya', route: '/office/finance/laporan' },
      { id: 'inventory', name: 'Stok & Inventori', route: '/office/finance/inventory' },
      { id: 'assets', name: 'Aset Perusahaan', route: '/office/finance/assets' },
      { id: 'chart_of_accounts', name: 'Daftar Akun (COA)', route: '/office/finance/chart-of-accounts' },
      { id: 'reports_hub', name: 'Laporan Keuangan', route: '/office/finance/reports-hub' },
    ]
  },
  {
    id: 'purchasing',
    name: 'Purchasing',
    color: 'bg-blue-600 text-white',
    badgeColor: 'bg-blue-50 text-blue-700 border-blue-200',
    pages: [
      { id: 'all', name: 'Semua Halaman Purchasing' },
      { id: 'dashboard_purchasing', name: 'Dashboard Purchasing', route: '/office/purchasing' },
      { id: 'low_stock', name: 'Item Perlu Beli', route: '/office/purchasing/low-stock' },
      { id: 'items_to_buy', name: 'Item Dibutuhkan PO', route: '/office/purchasing/items-to-buy' },
      { id: 'items_po', name: 'Item Sudah PO', route: '/office/purchasing/items-po' },
      { id: 'purchasing_requests', name: 'Pengajuan Pembelian', route: '/office/purchasing/purchasing-requests' },
      { id: 'payables', name: 'Hutang Perusahaan', route: '/office/purchasing/payables' },
      { id: 'suppliers', name: 'Database Supplier', route: '/office/purchasing/suppliers' },
      { id: 'data_pemesan', name: 'Data Pemesan', route: '/office/purchasing/data-pemesan' },
      { id: 'documents', name: 'Library Dokumen', route: '/office/purchasing/documents' },
      { id: 'inventory', name: 'Stok & Inventori', route: '/office/purchasing/inventory' },
      { id: 'delivery', name: 'Surat Jalan & Pengiriman', route: '/office/purchasing/delivery' },
    ]
  },
  {
    id: 'production',
    name: 'Produksi',
    color: 'bg-amber-600 text-white',
    badgeColor: 'bg-amber-50 text-amber-700 border-amber-200',
    pages: [
      { id: 'all', name: 'Semua Halaman Produksi' },
      { id: 'dashboard_utama', name: 'Dashboard Utama', route: '/office/production' },
      { id: 'po_list', name: 'Daftar PO Produksi', route: '/office/production/po-list' },
      { id: 'sample', name: 'Sample', route: '/office/production/sample' },
      { id: 'brands', name: 'Database Brand', route: '/office/production/brands' },
      { id: 'inventory', name: 'Stok & Inventori', route: '/office/production/inventory' },
      { id: 'delivery', name: 'Delivery', route: '/office/production/delivery' },
      { id: 'return', name: 'Return', route: '/office/production/return' },
      { id: 'reports', name: 'Laporan', route: '/office/production/reports' },
      { id: 'reject_tracking', name: 'Laporan Reject', route: '/office/production/reject-tracking' },
      { id: 'tasks', name: 'Tugas Saya', route: '/office/production/tasks' },
    ]
  },
  {
    id: 'marketing',
    name: 'Marketing',
    color: 'bg-purple-600 text-white',
    badgeColor: 'bg-purple-50 text-purple-700 border-purple-200',
    pages: [
      { id: 'all', name: 'Semua Halaman Marketing' },
      { id: 'dashboard_marketing', name: 'Dashboard Marketing', route: '/office/marketing' },
      { id: 'ranking', name: 'Ranking Omset', route: '/office/marketing/ranking' },
      { id: 'client_data', name: 'Data Klien', route: '/office/marketing/client-data' },
      { id: 'sample', name: 'Sample Racikan', route: '/office/marketing/sample' },
      { id: 'profit_sample', name: 'Margin Sample', route: '/office/marketing/profit-sample' },
      { id: 'brands', name: 'Database Brand', route: '/office/marketing/brands' },
      { id: 'calculator', name: 'Pembuatan Invoice & SPH', route: '/office/marketing/calculator' },
      { id: 'sph_list', name: 'Daftar SPH', route: '/office/marketing/sph-list' },
      { id: 'invoices', name: 'Invoice & PO', route: '/office/marketing/invoices' },
      { id: 'custom_invoices', name: 'Invoice Custom & Sample', route: '/office/marketing/custom-invoices' },
      { id: 'receivables', name: 'Piutang Klien', route: '/office/marketing/receivables' },
      { id: 'tasks_report', name: 'Tugas & Waktu Produksi', route: '/office/marketing/tasks-report' },
      { id: 'inventory', name: 'Stok & Inventori', route: '/office/marketing/inventory' },
    ]
  },
  {
    id: 'workspace',
    name: 'Workspace',
    color: 'bg-rose-600 text-white',
    badgeColor: 'bg-rose-50 text-rose-700 border-rose-200',
    pages: [
      { id: 'all', name: 'Semua Halaman Workspace' },
      { id: 'dashboard_workspace', name: 'Dashboard Workspace', route: '/office/workspace' },
      { id: 'clients', name: 'Klien Terverifikasi', route: '/office/workspace/clients' },
      { id: 'absensi', name: 'Absensi (ADMS)', route: '/office/workspace/absensi' },
      { id: 'simulasi_biaya', name: 'Simulasi Biaya Produksi', route: '/office/workspace/simulasi-biaya' },
      { id: 'team', name: 'Pengguna & Role', route: '/office/workspace/team' },
      { id: 'access', name: 'Hak Akses & Notifikasi', route: '/office/workspace/access' },
      { id: 'activity_log', name: 'Log Aktivitas', route: '/office/workspace/activity-log' },
      { id: 'settings', name: 'Pengaturan Perusahaan', route: '/office/workspace/settings' },
      { id: 'batch_database', name: 'Database No. Batch', route: '/office/workspace/batch-database' },
      { id: 'dip_generator', name: 'DIP Generator', route: '/office/workspace/dip-generator' },
      { id: 'backup', name: 'Backup & Restore', route: '/office/workspace/backup' },
      { id: 'history', name: 'Gudang Arsip (History)', route: '/office/workspace/history' },
    ]
  },
  {
    id: 'analytics',
    name: 'Analytics',
    color: 'bg-cyan-600 text-white',
    badgeColor: 'bg-cyan-50 text-cyan-700 border-cyan-200',
    pages: [
      { id: 'all', name: 'Semua Halaman Analytics' },
      { id: 'dashboard', name: 'Dashboard Analytics', route: '/office/analytics' },
      { id: 'margin_keseluruhan', name: 'Margin Keseluruhan', route: '/office/analytics/margin-keseluruhan' },
      { id: 'laporan_keuangan', name: 'Laporan Keuangan', route: '/office/analytics/laporan-keuangan' },
      { id: 'margin_po', name: 'Margin PO', route: '/office/analytics/margin-po' },
      { id: 'margin_sample', name: 'Margin Sample', route: '/office/analytics/margin-sample' },
      { id: 'margin_custom', name: 'Margin Custom', route: '/office/analytics/margin-custom' },
      { id: 'ranking', name: 'Ranking Omset', route: '/office/analytics/ranking' },
      { id: 'omset', name: 'Omset', route: '/office/analytics/omset' },
      { id: 'payables_receivables', name: 'Hutang & Piutang', route: '/office/analytics/payables-receivables' },
    ]
  }
];

const ID_TO_STAFF = {
  'id_sc9qsjrd2': 'Muhammad Fadli',
  'DEV-SDE-001': 'Muhammad Fadli',
  'fadli': 'Muhammad Fadli',
  'id_kslzqma18': 'Umar Syarif',
  'umar123': 'Umar Syarif',
  'umar': 'Umar Syarif',
  'id_43cbapon7': 'Anissa Nurul Fadilah',
  'ANF-MSH2510': 'Anissa Nurul Fadilah',
  'anissa': 'Anissa Nurul Fadilah',
  'ica': 'Anissa Nurul Fadilah',
  'id_ui0pd1xuu': 'Ahmad Rifai',
  'Rifay123': 'Ahmad Rifai',
  'rifai': 'Ahmad Rifai',
  'id_nil8a58h3': 'Adnan Hasan',
  'adnan123': 'Adnan Hasan',
  'adnan': 'Adnan Hasan',
  'id_4y7jbmaaw': 'Ahmad',
  'ahmad123': 'Ahmad',
  'id_dsyijdowr': 'Yositasari',
  'Yosi123': 'Yositasari',
  'yosi': 'Yositasari',
  'yosita': 'Yositasari',
  'id_xjcsapr84': 'Mohamad Irpan',
  'nabil123': 'Mohamad Irpan',
  'nabil': 'Mohamad Irpan',
  'irpan': 'Mohamad Irpan',
  'id_662p3rhd9': 'Agus Setiawan',
  'Agus123': 'Agus Setiawan',
  'agus': 'Agus Setiawan'
};

/**
 * Match a text, raw name, or employee_id string against the official 14 team members
 */
export function resolveTeamMember(rawName = '', fallbackDept = 'Office') {
  if (!rawName) {
    if (fallbackDept === 'Purchasing') return OFFICIAL_TEAM_MEMBERS.find(m => m.name === 'Ahmad Rifai');
    if (fallbackDept === 'Finance') return OFFICIAL_TEAM_MEMBERS.find(m => m.name === 'Anissa Nurul Fadilah');
    if (fallbackDept === 'Marketing') return OFFICIAL_TEAM_MEMBERS.find(m => m.name === 'Ahmad');
    if (fallbackDept === 'Produksi') return OFFICIAL_TEAM_MEMBERS.find(m => m.name === 'Mohamad Irpan');
    if (fallbackDept === 'Apoteker') return OFFICIAL_TEAM_MEMBERS.find(m => m.name === 'Yositasari');
    return { name: 'Tim Satala', role: 'Staff', dept: fallbackDept };
  }

  const str = String(rawName).trim();
  const lower = str.toLowerCase();

  // 1. Direct ID / Nickname dictionary match
  if (ID_TO_STAFF[str] || ID_TO_STAFF[lower]) {
    const targetName = ID_TO_STAFF[str] || ID_TO_STAFF[lower];
    const found = OFFICIAL_TEAM_MEMBERS.find(m => m.name === targetName);
    if (found) return found;
  }

  // 2. Official names lookup
  for (const member of OFFICIAL_TEAM_MEMBERS) {
    const memName = member.name.toLowerCase();
    if (lower === memName || lower.includes(memName) || memName.includes(lower)) {
      return member;
    }
  }

  // 3. Substring checks
  for (const [key, val] of Object.entries(ID_TO_STAFF)) {
    if (lower.includes(key.toLowerCase())) {
      const found = OFFICIAL_TEAM_MEMBERS.find(m => m.name === val);
      if (found) return found;
    }
  }

  return { name: rawName, role: 'Staff', dept: fallbackDept };
}

/**
 * Log a user action to the activity log in Supabase
 */
export async function logActivity({
  portal = 'workspace',
  page = '',
  action_type = 'other',
  title,
  details = '',
  amount = null,
  account = '',
  target_id = '',
  target_name = '',
  user_name = '',
  user_role = '',
  metadata = {}
}) {
  try {
    const sessionUser = typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('satala_member') || '{}') : {};
    const matched = resolveTeamMember(user_name || sessionUser.full_name || sessionUser.name, portal);
    
    const finalUserName = matched.name;
    const finalUserRole = user_role || matched.role;

    const payload = {
      portal: portal.toLowerCase(),
      page: page.toLowerCase() || 'general',
      action_type: action_type.toLowerCase(),
      title,
      details,
      amount: amount !== null ? Number(amount) : null,
      account,
      target_id,
      target_name,
      user_name: finalUserName,
      user_role: finalUserRole,
      created_date: new Date().toISOString(),
      metadata
    };

    if (base44?.entities?.ActivityLog) {
      await base44.entities.ActivityLog.create(payload);
    }
  } catch (err) {
    console.warn('[ActivityLogger] Gagal merekam log aktivitas:', err);
  }
}

/**
 * Helper to infer sub-page from action/description
 */
function inferSubPage(portal, desc = '', title = '') {
  const text = (desc + ' ' + title).toLowerCase();
  
  if (portal === 'finance') {
    if (text.includes('gaji') || text.includes('payroll')) return 'payroll';
    if (text.includes('operasional') || text.includes('listrik') || text.includes('ongkir')) return 'operasional';
    if (text.includes('bahan baku') || text.includes('hpp') || text.includes('produksi')) return 'production_costs';
    if (text.includes('invoice') || text.includes('po #')) return 'invoice_po';
    if (text.includes('rekening') || text.includes('mutasi')) return 'rekening_kas';
    return 'rekening_kas';
  }

  if (portal === 'purchasing') {
    if (text.includes('pengajuan') || text.includes('pembelian')) return 'purchasing_requests';
    if (text.includes('po') || text.includes('vendor')) return 'items_po';
    return 'purchasing_requests';
  }

  if (portal === 'production') {
    if (text.includes('sample') || text.includes('racikan')) return 'sample';
    if (text.includes('batch') || text.includes('spk') || text.includes('brand')) return 'brands';
    if (text.includes('keluar') || text.includes('kirim') || text.includes('delivery')) return 'delivery';
    if (text.includes('po')) return 'po_list';
    if (text.includes('tugas')) return 'tasks';
    return 'dashboard_utama';
  }

  if (portal === 'marketing') {
    if (text.includes('sph')) return 'sph_list';
    if (text.includes('sample')) return 'sample';
    if (text.includes('brand')) return 'brands';
    return 'invoices';
  }

  if (portal === 'workspace') {
    if (text.includes('absen') || text.includes('presensi') || text.includes('check_in') || text.includes('check_out')) return 'absensi';
    if (text.includes('user') || text.includes('anggota') || text.includes('staf') || text.includes('team')) return 'team';
    if (text.includes('akses') || text.includes('notif')) return 'access';
    return 'settings';
  }

  return 'all';
}

/**
 * Fetches unified activity logs combining all historical & live audit trails
 */
export async function fetchUnifiedActivityLogs() {
  const unifiedLogs = [];

  try {
    const promises = [];

    // 1. Direct ActivityLogs
    if (base44?.entities?.ActivityLog) {
      promises.push(
        base44.entities.ActivityLog.list('-created_date').then(explicitLogs => {
          (explicitLogs || []).forEach(log => {
            const mem = resolveTeamMember(log.user_name, log.portal);
            unifiedLogs.push({
              id: log.id || `act_${Math.random()}`,
              timestamp: log.created_date || log.created_at || new Date().toISOString(),
              portal: (log.portal || 'workspace').toLowerCase(),
              page: (log.page || 'all').toLowerCase(),
              action_type: log.action_type || 'other',
              title: log.title || 'Aktivitas Sistem',
              details: log.details || '',
              amount: log.amount || null,
              account: log.account || '',
              target_id: log.target_id || '',
              target_name: log.target_name || '',
              user_name: mem.name,
              user_role: mem.role,
              source: 'activity_log'
            });
          });
        }).catch(() => {})
      );
    }

    // 2. AccountMutation (Finance)
    if (base44?.entities?.AccountMutation) {
      promises.push(
        base44.entities.AccountMutation.list('-created_date').then(mutations => {
          (mutations || []).forEach(m => {
            if (!m || !m.id || m.status === 'rejected' || m.status === 'cancelled') return;
            const isMasuk = m.type === 'masuk';
            const amt = Number(m.amount) || 0;
            const desc = m.description || '';
            
            let portal = 'finance';
            let action_type = isMasuk ? 'payment' : 'expense';

            if (desc.toLowerCase().includes('bahan baku') || desc.toLowerCase().includes('pembelian')) {
              portal = 'purchasing';
            } else if (desc.toLowerCase().includes('gaji')) {
              portal = 'finance';
            }

            const page = inferSubPage(portal, desc, m.title || '');
            const rawUser = m.diinput_oleh || (desc.includes('PIC:') ? desc.split('PIC:')[1]?.trim() : '') || 'Anissa Nurul Fadilah';
            const mem = resolveTeamMember(rawUser, portal);

            unifiedLogs.push({
              id: `mut_${m.id}`,
              timestamp: m.created_date || m.date || new Date().toISOString(),
              portal,
              page,
              action_type,
              title: isMasuk ? `Uang Masuk: ${desc.replace(/\[.*?\]/g, '').trim() || 'Pembayaran'}` : `Uang Keluar: ${desc.replace(/\[.*?\]/g, '').trim() || 'Pengeluaran'}`,
              details: `Nominal: Rp ${amt.toLocaleString('id-ID')} ${m.account ? `• Rekening: ${m.account}` : ''} ${m.catatan ? `• Catatan: ${m.catatan}` : ''}`,
              amount: amt,
              type: m.type,
              account: m.account || '',
              target_id: m.invoice_id || m.reference_id || '',
              target_name: m.invoice_name || '',
              user_name: mem.name,
              user_role: mem.role,
              source: 'account_mutation'
            });
          });
        }).catch(() => {})
      );
    }

    // 3. PurchasingRequest (Purchasing)
    if (base44?.entities?.PurchasingRequest) {
      promises.push(
        base44.entities.PurchasingRequest.list('-created_date').then(prs => {
          (prs || []).forEach(pr => {
            if (!pr || !pr.id) return;
            const rawUser = pr.pic || pr.nama_sales || 'Ahmad Rifai';
            const mem = resolveTeamMember(rawUser, 'Purchasing');
            const total = Number(pr.total_biaya || pr.total_barang) || 0;
            
            unifiedLogs.push({
              id: `pr_${pr.id}`,
              timestamp: pr.created_date || new Date().toISOString(),
              portal: 'purchasing',
              page: 'purchasing_requests',
              action_type: pr.status === 'Sudah Dibayar' ? 'approval' : 'create',
              title: `Pengajuan Pembelian: ${pr.nama_item || 'Bahan Baku'}`,
              details: `Vendor: ${pr.atas_nama || '-'} • Kategori: ${pr.kategori || 'Bahan'} • Total: Rp ${total.toLocaleString('id-ID')} • Status: ${pr.status || 'Pending'}`,
              amount: total,
              account: pr.bank_tujuan || '',
              target_id: pr.id,
              target_name: pr.nama_item || '',
              user_name: mem.name,
              user_role: mem.role,
              source: 'purchasing_request'
            });
          });
        }).catch(() => {})
      );
    }

    // 4. ClientPO (Marketing Creation)
    if (base44?.entities?.ClientPO) {
      promises.push(
        base44.entities.ClientPO.list('-created_date').then(pos => {
          (pos || []).forEach(po => {
            if (!po || !po.id) return;
            const d = po.data || po;
            const pic = d.pic || d.sales || 'Ahmad';
            const mem = resolveTeamMember(pic, 'Marketing');
            const grandTotal = Number(d.grand_total || d.total_amount || d.harga_jual) || 0;

            unifiedLogs.push({
              id: `po_mkt_${po.id}`,
              timestamp: po.created_date || d.tanggal_order || new Date().toISOString(),
              portal: 'marketing',
              page: 'invoices',
              action_type: 'create',
              title: `Pembuatan Invoice / PO: ${d.customerName || d.brand_name || po.id}`,
              details: `No. PO: ${po.id} • PIC Sales: ${mem.name} • Status: ${d.status || 'Draft'} • Total: Rp ${grandTotal.toLocaleString('id-ID')}`,
              amount: grandTotal > 0 ? grandTotal : null,
              target_id: po.id,
              target_name: d.customerName || d.brand_name || '',
              user_name: mem.name,
              user_role: mem.role,
              source: 'client_po'
            });
          });
        }).catch(() => {})
      );
    }

    // 5. AttendanceLog (Workspace Portal -> Absensi)
    if (base44?.entities?.AttendanceLog) {
      promises.push(
        base44.entities.AttendanceLog.list('-timestamp').then(atts => {
          (atts || []).forEach(att => {
            if (!att || !att.id) return;
            const d = att.data || att;
            const isCheckIn = d.type === 'check_in';
            const mem = resolveTeamMember(d.employee_name || d.employee_id, 'Produksi');

            unifiedLogs.push({
              id: `att_${att.id}`,
              timestamp: d.timestamp || att.created_date || new Date().toISOString(),
              portal: 'workspace',
              page: 'absensi',
              action_type: 'approval',
              title: `${isCheckIn ? 'Presensi Masuk (Check-In)' : 'Presensi Pulang (Check-Out)'}: ${mem.name}`,
              details: `Status: ${d.status || 'Hadir'} • ${d.notes || 'Area Kantor'} ${d.location ? `• GPS: ${d.location}` : ''}`,
              amount: null,
              target_id: d.employee_id || '',
              target_name: mem.name,
              user_name: mem.name,
              user_role: mem.role,
              source: 'attendance_log'
            });
          });
        }).catch(() => {})
      );
    }

    // 6. SampleRacikan (Production Portal -> Sample)
    if (base44?.entities?.SampleRacikan) {
      promises.push(
        base44.entities.SampleRacikan.list('-created_date').then(samples => {
          (samples || []).forEach(s => {
            if (!s || !s.id) return;
            const d = s.data || s;
            const authorRaw = d.pic_pembuat || d.dikerjakan_oleh || d.products?.[0]?.dikerjakan_oleh || d.pic_brand || 'Yositasari';
            const mem = resolveTeamMember(authorRaw, 'Apoteker');
            const brand = d.nama_brand || d.brand_name || 'Brand';
            const product = d.nama_produk || d.products?.[0]?.nama_produk || '';
            const prodCount = d.products?.length || 1;

            unifiedLogs.push({
              id: `sample_${s.id}`,
              timestamp: s.created_date || new Date().toISOString(),
              portal: 'production',
              page: 'sample',
              action_type: 'create',
              title: `Formulasi Sample: ${brand} ${product ? `(${product})` : ''}`,
              details: `Brand: ${brand} • ${prodCount} varian • PIC Pembuat: ${mem.name} • Sales: ${d.pic_brand || '-'} • Status: ${d.status || 'Pending'}`,
              amount: null,
              target_id: s.id,
              target_name: brand,
              user_name: mem.name,
              user_role: mem.role,
              source: 'sample_racikan'
            });
          });
        }).catch(() => {})
      );
    }

    // 7. BarangKeluar (Production Portal -> Delivery)
    if (base44?.entities?.BarangKeluar) {
      promises.push(
        base44.entities.BarangKeluar.list('-created_date').then(bks => {
          (bks || []).forEach(bk => {
            if (!bk || !bk.id) return;
            const d = bk.data || bk;
            const mem = resolveTeamMember(d.checker || d.pic || 'Mohamad Irpan', 'Produksi');

            unifiedLogs.push({
              id: `bk_${bk.id}`,
              timestamp: bk.created_date || new Date().toISOString(),
              portal: 'production',
              page: 'delivery',
              action_type: 'create',
              title: `Pengiriman Barang Keluar: ${d.brand_name || d.customer_name || 'Klien'}`,
              details: `Ekspedisi/Kurir: ${d.ekspedisi || d.kurir || '-'} • No. Resi/Surat Jalan: ${d.no_resi || d.surat_jalan || '-'} • Total Qty: ${d.total_qty || '-'} pcs`,
              amount: Number(d.ongkir) || null,
              target_id: bk.id,
              target_name: d.brand_name || '',
              user_name: mem.name,
              user_role: mem.role,
              source: 'barang_keluar'
            });
          });
        }).catch(() => {})
      );
    }

    // 8. ClientAccount (Marketing Portal -> Data Klien)
    if (base44?.entities?.ClientAccount) {
      promises.push(
        base44.entities.ClientAccount.list('-created_date').then(clients => {
          (clients || []).forEach(c => {
            if (!c || !c.id) return;
            const d = c.data || c;
            const mem = resolveTeamMember(d.pic_sales || 'Adnan Hasan', 'Marketing');

            unifiedLogs.push({
              id: `client_${c.id}`,
              timestamp: c.created_date || new Date().toISOString(),
              portal: 'marketing',
              page: 'client_data',
              action_type: 'create',
              title: `Pendaftaran Brand Klien Baru: ${d.brand_name || d.company_name || 'Brand Klien'}`,
              details: `Email: ${d.email || '-'} • PIC Klien: ${d.pic || '-'} • Status: ${d.status || 'Verified'}`,
              amount: null,
              target_id: c.id,
              target_name: d.brand_name || '',
              user_name: mem.name,
              user_role: mem.role,
              source: 'client_account'
            });
          });
        }).catch(() => {})
      );
    }

    await Promise.all(promises);
  } catch (err) {
    console.error('[ActivityLogger] Error generating unified logs:', err);
  }

  // Filter out all historical activities before 1 September 2026 (Fresh Start)
  const cutoffTime = new Date('2026-09-01T00:00:00+07:00').getTime();
  const freshLogs = unifiedLogs.filter(l => {
    if (!l.timestamp) return false;
    return new Date(l.timestamp).getTime() >= cutoffTime;
  });

  // Sort newest first
  return freshLogs.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
}
